import iframeResize from "@iframe-resizer/parent";

iframeResize({
    license: 'GPLv3',
    sizeSelector: '#embedded-iframe',
    waitForLoad: true,
    onMessage: post => {
        if (post.message?.height > 0) {
            post.iframe.style.height = `${post.message.height}px`;
        }
    },
}, '#embedded-iframe');